<template>
  <div id="mainview">
    <Back />
    <Car />
    <el-main>
      <div id="container" @keydown="onKeyDown($event)" @keyup="onKeyUp($event)"></div>
    </el-main>

    <transition
      enter-active-class="animated zoomIn"
      leave-active-class="animated zoomOut"
    >
      <div class="roamList" v-if="show">
        <div
          :class="value == index ? 'active list' : 'list'"
          v-for="(item, index) in list"
          :key="index"
          @click="get(index)"
        >
          {{ item }}
        </div>
      </div>
    </transition>
    <img
      src="../assets/roam.png"
      class="roam"
      @click="
        show = !show;
        value = -1;
      "
    />
  </div>
</template>

<script>
import Event from "./../lib/event.js";
import * as THREE from "three/build/three.module";
import Car from "../../common/components/Car1.vue";
import Back from "../components/back.vue";
export default {
  name: "MainView",
  components: {
    Car,
    Back,
  },
  data() {
    return {
      desc: "3D View",
      O2: {},
      selObj: {},
      url: "",
      SCREEN_WIDTH: 800,
      SCREEN_HEIGHT: 600,
      btnDown: {
        x: 0,
        y: 0,
      },
      mouse: {
        x: 0,
        y: 0,
      },
      mouse_down: {
        x: 0,
        y: 0,
      },

      list: ["入口空间", "休闲空间", "儿童活动场地"],
      show: false,
      value: -1,
    };
  },
  methods: {
    start3D() {
      ///////////////
      console.log("init scene");
      let o2world = [];
      let container = document.getElementById("container");
      this.SCREEN_WIDTH = container.clientWidth;
      this.SCREEN_HEIGHT = container.clientHeight;
      let O2vr = this.O2vr;
      O2vr.init(container);
      o2world.o2 = O2vr;
      document.o2 = O2vr;
      if (this.O2Builder) {
        let builder = this.O2Builder;
        builder.init(O2vr);
        o2world.builder = builder;
      }

      this.$parent.O2World = o2world;
      document.o2 = O2vr;
      let ppp = this.O2vr.load_zip_scene(
        "https://o2res.oss-cn-beijing.aliyuncs.com/dingzhou/%E5%AE%9A%E5%B7%9EWebgl.zip?OSSAccessKeyId=LTAI4G4zQbTdurvEbr1rR9zS&Expires=36001649412557&Signature=XoQ4SP8oEQ2SJlWmJlLwigi%2Fggo%3D"
      );

      {
        this.O2vr.script = {};
        let scripts = this.O2vr.script;
        let _o2 = this.O2vr;
        let last_mouse_down = Date.now();
        _o2.dist_appear = false;
        scripts["init"] = function init() {
          console.log("inited");
          _o2.on_loading_msg("正在下载:", String(Math.ceil(100)), "%");

          // 461.9075391606356, y: 13100.657352320348, z: -370.913677594644
          document.o2.switch_camera(0, 0, 0, 2, 5041, 7810);
          _o2.cameraControls.maxPolarAngle = Math.PI / 2 - Math.PI / 15;

          let tm1 = _o2.search_obj_by_name("tm1");
          if (tm1) {
            _o2.map_tm1 = tm1.material.map;
            _o2.tm1 = tm1;
          }
          let tm2 = _o2.search_obj_by_name("tm2");
          if (tm2) {
            _o2.map_tm2 = tm2.material.map;
            _o2.tm2 = tm2;
            tm2.visible = false;
          }
          let tm3 = _o2.search_obj_by_name("tm3");
          if (tm3) {
            _o2.map_tm3 = tm3.material.map;
            _o2.tm3 = tm3;
            tm3.visible = false;
          }

          let d1 = _o2.search_obj_by_name("D1");
          if (d1) {
            _o2.map_d1 = d1.material.map;
            _o2.d1 = d1;
          }
          let d2 = _o2.search_obj_by_name("D2");
          if (d2) {
            _o2.map_d2 = d2.material.map;
          }
          let d3 = _o2.search_obj_by_name("D3");
          if (d3) {
            _o2.map_d3 = d3.material.map;
          }
          _o2.gz = [];
          _o2.flash_alpha = 0;
          for (let i = 0; i < 6; i++) {
            let name = "g" + i;
            let obj = _o2.search_obj_by_name(name);
            if (obj) {
              _o2.gz.push(obj);
            }
          }
          _o2.boxes = [];
          for (let i = 1; i < 7; i++) {
            let name = "B" + i;
            let obj = _o2.search_obj_by_name(name);
            if (obj) {
              obj.visible = false;
              _o2.boxes.push(obj);
            }
          }
          console.log(_o2.boxes);

          let g1 = _o2.search_obj_by_name("g3");
          if (g1) {
            _o2.map_g1 = g1.material.map;
          }
          let g2 = _o2.search_obj_by_name("x2");
          if (g2) {
            _o2.map_g2 = g2.material.map;
            g2.visible = false;
          }
          let g3 = _o2.search_obj_by_name("x3");
          if (g3) {
            _o2.map_g3 = g3.material.map;
            g3.visible = false;
          }
          let g4 = _o2.search_obj_by_name("g1");
          if (g4) {
            _o2.map_g4 = g4.material.map;
          }
        };
        scripts["frame_move"] = function init(time_passed) {
          if (_o2.current_flash) {
            _o2.flash_alpha = _o2.flash_alpha + time_passed * 0.5;
            if (_o2.flash_alpha > 1) _o2.flash_alpha -= 1;

            let alpha = Math.abs(_o2.flash_alpha - 0.5) * 0.4;
            _o2.current_flash.material.opacity = alpha;
          }
        };
        console.log(document.o2.script);

        function onDocumentClick(event) {
          let time2 = Date.now();
          if (time2 - last_mouse_down > 100) {
            return;
          }
          event.preventDefault();
          let intersects = _o2.ray_test(event);
          if (intersects.length > 0) {
            console.log(intersects[0].object.name);
            let object = intersects[0].object;
            let str =
              Math.round(_o2.cameraControls.target.x) +
              "," +
              Math.round(_o2.cameraControls.target.y) +
              "," +
              Math.round(_o2.cameraControls.target.z) +
              ",";
            str =
              str +
              Math.round(_o2.camera.position.x) +
              "," +
              Math.round(_o2.camera.position.y) +
              "," +
              Math.round(_o2.camera.position.z);
            console.log(str);
          } else {
          }
        }
        function onMouseDown(event) {
          last_mouse_down = Date.now();
        }
        _o2.container.addEventListener("click", onDocumentClick, false);
        _o2.container.addEventListener("pointerdown", onMouseDown, false);
      }

      ppp.then(() => {
        console.log("load ended");
        Event.$emit("afterSceneOpened");
      });
      //  document.o2.cameraControls.enablePan = true;
      //  document.o2.cameraControls.panSpeed = 0.1;
    },

    get(e) {
      console.log(e);
      this.value = e;
      if (e == 0) {
        document.o2.switch_camera(-64, -15, 3, -63, 1012, 4839);
      } else if (e == 1) {
        document.o2.switch_camera(58, -1094, -98, 39, 3465, 1870);
      } else if (e == 2) {
        document.o2.switch_camera(2872, 2788, -32, 2872, 3048, -32);
      }
    },
  },

  watch: {
    show(val) {
      console.log(val);
      if (val == false) {
        document.o2.switch_camera(0, 0, 0, 2, 5041, 7810);
      }
    },
  },
  created() {
    // Ammo().then(function (e) {
    //   Ammo = e;
    //   console.log(Ammo);
    //   console.log("111");
    // });
  },
  mounted() {
    //在模板编译完成后执行
    document.addEventListener("keydown", this.onKeyDown, false);
    document.addEventListener("keyup", this.onKeyUp, false);

    //新增获取query

    this.start3D();

    Event.$on("toolsChanged", (idx) => {
      //箭头函数内部不会产生新的this，这边如果不用=>,this指代Event
      //console.log(Event)
      //alert('监听到消息:'+idx)
      console.log("ToolBar message");
      console.log(idx);
      switch (idx) {
        case "1":
          {
          }
          break;
        case "2":
          {
          }
          break;
        case "3":
          {
          }
          break;
        case "4":
          {
            this.O2vr.set_gizmo_mode("translate");
          }
          break;
        case "5":
          {
            this.O2vr.set_gizmo_mode("rotate");
          }
          break;
        case "6":
          {
            this.O2vr.set_gizmo_mode("scale");
          }
          break;
        default:
          {
            alert(idx);
            alert("default");
          }
          break;
      }
    });

    Event.$on("propsChanged", (obj) => {
      //箭头函数内部不会产生新的this，这边如果不用=>,this指代Event
      //console.log(Event)
      //alert('监听到消息:'+idx)
      console.log("Prop message");
      console.log(obj);
      this.setProp(obj);
    });
  },
};
</script>

<style lang="scss" scoped>
#mainview,
#container {
  height: 100%;
  width: 100%;
  overflow: hidden;
}

.el-main {
  padding: 0 !important;
  background-color: #e9eef3;
  color: #333;
  height: 100%;
}

.roam {
  position: fixed;
  right: 20px;
  bottom: 40px;
}

.roamList {
  right: 20px;
  bottom: 100px;
  position: fixed;
  .list {
    width: 160px;
    height: 44px;
    background: rgba($color: #fff, $alpha: 1);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-family: Source Han Sans CN, Source Han Sans CN-Regular;
    font-weight: 400;
    text-align: left;
    color: #333333;
    line-height: 18px;
    opacity: 0.7;
  }

  .active {
    background: #ffbc1e;
    color: #fff;
    opacity: 1;
    transition: 0.5s;
  }
}
</style>
